import styled from '@emotion/styled'

import { GroupOrderProp, InputWithVariant } from '../framework/interfaces'

export interface InputProps extends GroupOrderProp, InputWithVariant {
  disabled?: boolean
  hasErrors?: boolean
  hasIconLeft?: boolean
}

export const RoundedInput = styled.div<InputProps>(
  ({ theme }) => theme.fontSmooth,
  (props) => ({
    ...props.theme.fonts.inputText2,
    backgroundColor: 'white',
    border: `1px solid ${props.theme.colors.iconGray}`,
    borderRadius: '5px',
    cursor: 'pointer',
    display: 'block',
    fontFamily: props.theme.fonts.families.body,
    height: '36px',
    minHeight: '40px',
    padding: `13px 10px 13px ${props.theme.paddings.inputPaddingLeft}`,
    position: 'relative',
    width: '100%',
    tabindex: 0,
    color: 'black',
    ':focus-within': props.theme.borders.focus,
    ':placeholder-shown': {
      color: props.theme.colors.iconGray,
    },
  }),
  ({ variant }) =>
    variant === 'small' && {
      minHeight: '24px',
      maxHeight: '24px',
      padding: `3px 5px 3px 10px`,
      fontSize: '12px',
    },
  (props) =>
    props.hasIconLeft && {
      paddingLeft: '2.2em',
    },
  (props) =>
    // note: this must come before the groupOrder styles
    props.hasErrors && {
      border: `1px solid ${props.theme.colors.danger}`,
    },
  (props) =>
    props.groupOrder === 'start' && {
      borderTopRightRadius: '0px',
      borderBottomRightRadius: '0px',
      borderRight: `1px solid ${props.theme.colors.grays.grayLight}`,
    },
  (props) =>
    props.groupOrder === 'end' && {
      borderTopLeftRadius: '0px',
      borderBottomLeftRadius: '0px',
      borderLeft: '0px',
    },
  (props) =>
    props.groupOrder === 'middle' && {
      borderRadius: '0px',
      borderRight: `1px solid ${props.theme.colors.grays.grayLight}`,
      borderLeft: '0px',
    },
  (props) =>
    props.disabled && {
      cursor: 'not-allowed',
      opacity: props.theme.opacities.disabledInput,
    }
)

export const GrayRoundedInput = styled(RoundedInput)(({ theme }) => ({
  backgroundColor: theme.colors.grays.grayLighter,
  boxShadow: 'none',
}))

export default RoundedInput
